import { render, staticRenderFns } from "./layout-center.vue?vue&type=template&id=2de51506&scoped=true&"
import script from "./layout-center.vue?vue&type=script&lang=js&"
export * from "./layout-center.vue?vue&type=script&lang=js&"
import style0 from "./layout-center.vue?vue&type=style&index=0&id=2de51506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de51506",
  null
  
)

export default component.exports